import { GA } from '../../feature/google-analytics/ga';

interface EventData {
  eventName: string;
  context: string;
  starRating?: number;
  thumbsRating?: boolean;
  question?: string;
  feedbackText?: string;
}

export const trackFeedbackSubmission = ({ eventName, ...data }: EventData) =>
  GA.sendEvent({ event_name: `${eventName}_submission`, ...data });
